function lazyLoad () {
    const images = document.querySelectorAll("[data-src]")
    const imagesLazy = document.querySelectorAll('[data-src-lazy]')
    if(imagesLazy.length !== 0) {
        setTimeout(function () {
            imagesLazy.forEach(item => {
                const src = item.getAttribute("data-src-lazy")
                item.src = src
            })
        }, 3000)
    }
    const imgOptions = {
        threshold: 0,
        rootMargin: "0px 0px -200px 0px"
    };
    function preloadImage (img) {
        const src = img.getAttribute("data-src")
        if(!src) return
        img.src = src
    }
    const imgObserver = new IntersectionObserver((entries, imgObserver) => {
        entries.forEach(entry => {
            if(!entry.isIntersecting) return
            else {
                preloadImage(entry.target)
                imgObserver.unobserve(entry.target)
            }
        })
    }, imgOptions);
    images.forEach(image => {
        imgObserver.observe(image)
    })
}
export default lazyLoad